import constants from '#packages/constants';

import type { StyleRef } from '@wix/document-services-types';

const { PHOTO } = constants.COMP_TYPES;

export const paasHardCodedThemeStyles: Record<
  string,
  Record<string, StyleRef>
> = {
  [PHOTO]: {
    wp3: {
      type: 'ComponentStyle',
      styleType: 'custom',
      style: {
        properties: {
          shd: '0 1px 3px rgba(0, 0, 0, 0.5)',
          brw: 0,
          brd: 'color_11',
          'boxShadowToggleOn-shd': 'true',
          'alpha-brd': '1',
        },
        propertiesSource: {
          shd: 'value',
          brw: 'value',
          brd: 'theme',
          'boxShadowToggleOn-shd': 'value',
          'alpha-brd': 'value',
        },
        groups: {},
        propertiesOverride: {},
      },
      componentClassName: 'wysiwyg.viewer.components.WPhoto',
      pageId: '',
      compId: '',
      skin: 'wysiwyg.viewer.skins.photo.CirclePhoto',
    },
  },
};
